// CYBORG-1198: how long a returning page may have MISSED live broadcasts, which is
// what the foreground resync is for. A page that was never hidden (a window focus)
// missed nothing; a hidden page whose timers kept firing had its socket's events
// dispatched the whole time. Only a hidden page whose JS was stopped counts as away.

// Chrome throttles a hidden tab's timers to one wake a minute, so a shorter gap
// between ticks is a throttled timer, not a frozen page.
export const FROZEN_GAP_MS = 90_000;

export class ForegroundAway {
  private hiddenAt: number | null = null;
  private lastTick = 0;

  hidden(now: number): void {
    this.hiddenAt = now;
    this.lastTick = now;
  }

  // A timer that ran while hidden: proof the page was executing at `now`.
  tick(now: number): void {
    if (this.hiddenAt !== null) this.lastTick = now;
  }

  // The away time the resync gate should judge. `suspendsWhenHidden`: a mobile shell,
  // whose OS stops the page (and may drop its socket's frames) on every background.
  visible(now: number, suspendsWhenHidden: boolean): number {
    const hiddenAt = this.hiddenAt;
    this.hiddenAt = null;
    if (hiddenAt === null) return 0;
    const hiddenMs = now - hiddenAt;
    if (suspendsWhenHidden) return hiddenMs;
    return now - this.lastTick >= FROZEN_GAP_MS ? hiddenMs : 0;
  }
}
